<template>
    <div
        :id="elementName"
        :class="elementName"
    >
        <slot />
    </div>
</template>

<script>
import { watch, computed, ref } from 'vue'
export default {
    name: 'CloseOnClickOutside',
    props: {
        state: {
            type: Boolean,
            default: false
        },
        elementName: {
            type: String,
            default: 'click-outside-wrapper'
        }
    },
    emits: ['click-to-close'],
    setup (props, { emit }) {
        const isToggled = computed(() => props.state)
        const detectClickOutsideElem = ref(null)

        watch(isToggled, current => {
            if (current) {
                const body = document.getElementsByTagName('body')[0]
                const outsideWrapper = document.getElementById(props.elementName)
                const elemNotUnique = document.getElementsByClassName(props.elementName)

                if (elemNotUnique.length > 1) {
                    return console.error(`Click outside elementName: ${props.elementName} is not unique. Please pass a unique element name identifier!`)
                }

                body.addEventListener('click', function (e) {
                    if (!outsideWrapper.contains(e.target)) {
                        emit('click-to-close', false)
                    } else {
                        emit('click-to-close', props.state)
                    }
                })
            }
        })

        return { detectClickOutsideElem }
    }
}
</script>
